module.exports = __webpack_public_path__ + "static/img/Sensors 23.72241640.webp";